export default {
    getFilterRemainingCountForTestOption: function (filter, allResults) {
        // Rule Here:
        // don't count the record as "filtered" if it is only filtered by the category you just requested to open
        // This will determine what filters should display when opening up the filter modal.
        var c = 0;
        allResults.forEach((o) => {
            var filteredOther = false;

            for (var fbc = 0; fbc < o.filteredBy.length; fbc++) {
                if (o.filteredBy[fbc] != filter.category.id) {
                    filteredOther = true;
                }
            }
            if (!filteredOther && filter.test(o, filter.value)) {
                c++;
            }
        });
        return c;
    },

    getFilterRemainingExactCountForTestOption: function (filter, exactResults) {
        // Rule Here:
        // don't count the record as "filtered" if it is only filtered by the category you just requested to open
        // This will determine what filters should display when opening up the filter modal.
        var c = 0;
        exactResults.forEach((o) => {
            var skip = false;
            for (var fbc = 0; fbc < o.filteredBy.length; fbc++) {
                if (o.filteredBy[fbc] === filter.category.id) {
                    skip = true;
                    break;
                }
            }
            if ((o.filteredBy.length === 0 || skip) && filter.test(o, filter.value)) {
                c++;
            }
        });
        return c;
    },

    sortFunc: function (a, b) {
        var A = parseInt(a.SortOrder.replace(/-/g, ""));
        var B = parseInt(b.SortOrder.replace(/-/g, ""));

        if (A < B) {
            return -1;
        }

        if (A > B) {
            return 1;
        }

        return 0;
    },

    shuffleFunc: function (array) {
        var currentIndex = array.length,
            temporaryValue,
            randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
    },

    // These are used by the markup to get text for certain displays.
    manipulateAvailability: function (avail) {
        if (avail.indexOf("Non-Cancelable. Non-Returnable") > -1) {
            avail = avail.replace("Non-Cancelable. Non-Returnable", "Non-Cancelable<br />Non-Returnable");
        }
        return avail.replace(/(?:\r\n|\r|\n|<br\W?\/?>)+/g, "<br />");
    },

    getPartialDescription: function (str, maxLength) {
        if (str.length <= maxLength) {
            return str;
        }

        var partialDescription = str.substring(0, maxLength);
        var lastWordIndex = partialDescription.lastIndexOf(" ");
        if (lastWordIndex > 1) {
            partialDescription = partialDescription.substring(0, lastWordIndex);
        }
        return partialDescription;
    },

    getRoHS: function (obj, $t) {
        var results = [];
        if (obj != null && obj.length > 0) {
            var result = "";
            for (var i = 0; i < obj.length; i++) {
                var comp = obj[i];
                if (comp.Region && comp.Region !== "") {
                    result += comp.Region + ": ";
                }
                if (comp.Description && comp.Description !== "") {
                    result += comp.Description;
                } else if (comp.IsCompliant === true) {
                    result += $t("Global.Yes");
                } else if (comp.IsCompliant === false) {
                    result += $t("Global.No");
                } else {
                    result += $t("Search.NotApplicable");
                }
                if (result !== "") {
                    results.push(result);
                }
            }
            return results;
        }
    },

    distributorResultHasChildren: function (array_ref, item) {
        if (item.IsDistributorDuplicate || !Array.isArray(array_ref)) return false;
        return array_ref.some((x) => x.ParentSortOrder === item.SortOrder);
    },

    calculatePartsDisplayIndex: function (results) {
        var ix = 1;
        var parents = {};
        results.forEach((r) => {
            if (!r.IsDistributorDuplicate) {
                r.displayIndex = ix++;
                parents[r.SortOrder] = r.displayIndex;
            }
        });

        results.forEach((r) => {
            if (r.IsDistributorDuplicate) {
                r.displayIndex = parents[r.ParentSortOrder];
            }
        });
    },
};
